import React, { useState } from "react";
import Banner from "../../../assets/images/cart/banner.png";
import ShippingAndDetails from "./ShippingAndDetails";
import { Button, Col, Container, Input, Row, Nav, NavItem, NavLink } from "reactstrap";
import PaymentMethod from "./PaymentMethod";
import Finalize from "./Finalize";
import { SlTag } from "react-icons/sl";
import { RiCouponLine } from "react-icons/ri";
import BackButton from "../../../components/common/BackButton/BackButton";
import styles from './Checkout.module.scss';

const fiterTabs = [
  { id: '1', label: 'Shipping & Details' },
  { id: '2', label: 'Payment Method' },
  { id: '3', label: 'Finalize' },
];

const Checkout = () => {
  const [activeTab, setActiveTab] = useState('1');

  return (
    <div>
      <BackButton />

      <Container fluid className={styles.checkoutMainContainer}>
        <div className={styles.bannerContainer}>
          <img src={Banner} alt="Banner" />
          <span className={styles.checkoutHeading}>
            Checkout
          </span>
        </div>

        <Row noGutters className={styles.checkoutMainRow}>
          <Col lg={9}>
            <div className={styles.filterContainer}>
              <div className={styles.filterTabs}>
                <Nav className={styles.fiterTabsNavBar}>
                  {fiterTabs?.map((category) => (
                    <NavItem key={category.id} className={styles.navItem}>
                      <NavLink
                        className={`${styles.navLink} ${activeTab === category.id ? styles.activeTab : ""}`}
                        onClick={() => setActiveTab(category.id)}
                      >
                        {category.label}
                      </NavLink>
                    </NavItem>
                  ))}
                </Nav>
              </div>
              {activeTab === "1" && <ShippingAndDetails setActiveTab={setActiveTab} />}
              {activeTab === "2" && <PaymentMethod setActiveTab={setActiveTab} />}
              {activeTab === "3" && <Finalize />}
            </div>
          </Col>

          <Col lg={3}>
            <div className={styles.cartSummaryContainer}>
              <div className={styles.cartSummaryHeader}>
                <h4 className={styles.sectionHeading}>Cart Summary</h4>
                <div className={styles.btnConatiner}>
                  <Button color="link" className={styles.editBtn}>Edit</Button>
                </div>
              </div>

              <div>
                <div className="d-flex gap-2 align-items-center">
                  <div>
                    <img src="https://placehold.co/66x61?text=Maelano" alt="" className="rounded-2" />
                  </div>
                  <div>
                    <div>Purple Sports Shirt</div>
                    <div style={{ color: "#ea7231", fontWeight: 500 }}>$33.99</div>
                  </div>
                </div>

                <div className="d-flex gap-2 align-items-center mt-2">
                  <div>
                    <img src="https://placehold.co/66x61?text=Maelano" alt="" className="rounded-2" />
                  </div>
                  <div>
                    <div>Purple Sports Shirt</div>
                    <div style={{ color: "#ea7231", fontWeight: 500 }}>$33.99</div>
                  </div>
                </div>
              </div>

              <div className="my-2" style={{ height: "2px", backgroundColor: "#d9d9d9" }}></div>

              <div className="p-2">
                <div className="d-flex justify-content-between">
                  <span>Subtotal:</span>
                  <span>$67.98</span>
                </div>
                <div className="d-flex justify-content-between">
                  <span>Delivery Charges:</span>
                  <span>$67.98</span>
                </div>
                <div className="d-flex justify-content-between">
                  <span>Discount:</span>
                  <span>$67.98</span>
                </div>
              </div>

              <div className="my-2" style={{ height: "2px", backgroundColor: "#d9d9d9" }}></div>

              <div className="p-2">
                <div className="d-flex justify-content-between">
                  <span>Total:</span>
                  <span style={{ fontWeight: 500, color: "#EC7426", fontSize: "1.25rem" }}>$71.98</span>
                </div>
              </div>

              <div style={{ display: "grid", gap: ".3rem", backgroundColor: '#fcffdb', padding: '.5rem' }}>
                <div style={{ position: "relative" }}>
                  <Input placeholder="Applied Promotion" style={{ paddingLeft: "2rem" }} />
                  <span style={{ position: "absolute", top: "14%", left: "10px" }}>
                    <SlTag />
                  </span>
                </div>

                <div style={{ position: "relative" }}>
                  <Input placeholder="Coupon/Voucher Code" style={{ paddingLeft: "2rem" }} />
                  <span style={{ position: "absolute", top: "14%", left: "10px" }}>
                    <RiCouponLine />
                  </span>
                  <span style={{ position: "absolute", top: 0, right: 0 }}>
                    <Button className="btn-warning">Apply</Button>
                  </span>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  )
}

export default Checkout;